export default "__VITE_ASSET__DAv6OX$Q__"